import { SizeUnit } from 'src/components/TradeForm/SizeInput/types';
import { useSyncLocalStorage } from 'src/hooks/useSyncLocalStorage';

export default function useSizeInputSource() {
	return useSyncLocalStorage<SizeUnit>('tradeFormSizeInputSource', 'base');
}
